import { Canvas } from '../../../../lib/classes/Canvas';
import { drawGrid } from './drawGrid';
import { drawData } from './drawData';
import { cloneSlice } from '../../../../utils/cloneSlice';
import { alignSlices } from '../geometry/alignSlices';
import { drawSlices } from './drawSlices';
import { calcMaxEndGameScreenWidth } from '../geometry/calcMaxEndGameScreenWidth';
import { GRID_SIZE } from '../../../../app/const/game';
export function drawPreview(data, slices, slicesAlpha, cancelMoveFeature) {
    if (slicesAlpha === void 0) { slicesAlpha = 0.25; }
    if (cancelMoveFeature === void 0) { cancelMoveFeature = false; }
    var w = Math.max(300, calcMaxEndGameScreenWidth() - 40);
    var slicesPaddingTop = 20;
    var preview = new Canvas(w, Math.floor(w + slicesPaddingTop + 0.33 * w));
    preview.canvas.style.width = '100%';
    preview.canvas.style.height = 'auto';
    var cellSize = (w - 10) / GRID_SIZE;
    var gridPos = { x: 5, y: 5 };
    var gridSize = Math.floor(cellSize * GRID_SIZE);
    drawGrid(preview, cellSize, gridPos);
    drawData(preview, data, cellSize, GRID_SIZE, gridPos);
    var previewSlices = slices.map(cloneSlice);
    var slicesRect = { x: gridPos.x, y: gridPos.y + gridSize + slicesPaddingTop, w: gridSize, h: 0 };
    alignSlices(previewSlices, slicesRect);
    drawSlices(preview, previewSlices, cellSize, slicesAlpha, cancelMoveFeature);
    return preview;
}
